import clsx from 'clsx';
import { Icon } from 'ui';
import React from 'react';

import type { PracticeCourse } from '../../../types/practiceCourses';

type SubjectCardProps = {
  course: PracticeCourse;
  isSelected: boolean;
  onSelect: (courseId: string) => void;
};

function SubjectCard({ course, isSelected, onSelect }: SubjectCardProps): JSX.Element {
  function handleClick() {
    onSelect(course.id);
  }

  return (
    <li className="subject-selection-dialog__item">
      <button
        aria-pressed={isSelected}
        className={clsx('subject-selection-dialog__card', { 'subject-selection-dialog__card--selected': isSelected })}
        onClick={handleClick}
        type="button"
      >
        <span className="subject-selection-dialog__card-icon">
          <Icon color="inherit" name="program" size="xl" />
        </span>
        <span className="subject-selection-dialog__card-title">{course.title}</span>
      </button>
    </li>
  );
}

export default SubjectCard;
